import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hasObgyn", "obgynDetails"]
  static values = {
    hasObgyn: String
  }

  connect() {
    // Initially hide details and disable fields
    const requiredFields = this.obgynDetailsTarget.querySelectorAll("input[required], select[required]")
    requiredFields.forEach(field => {
      field.removeAttribute("required")
    })

    if (this.hasObgynValue === "obgyn_yes") {
      this.obgynDetailsTarget.classList.remove("hidden")
      requiredFields.forEach(field => {
        field.setAttribute("required", "")
      })
    }
  }

  updateHasObgyn(event) {
    const hasObgyn = event.target.value === "obgyn_yes"
    const requiredFields = this.obgynDetailsTarget.querySelectorAll("input, select")
    console.log("hasObgyn", hasObgyn)
    if (hasObgyn) {
      this.obgynDetailsTarget.classList.remove("hidden")
      requiredFields.forEach(field => {
        field.required = true
        field.removeAttribute('disabled')
      })
    } else {
      this.obgynDetailsTarget.classList.add("hidden")
      requiredFields.forEach(field => {
        field.required = false
        field.value = ""
        field.setAttribute('disabled', 'disabled')
      })
    }
  }
} 